import { load } from "@cashfreepayments/cashfree-js";
import { CASHFREE_ENV } from "../config/constants.config";

let cashfreePromise;

export const getCashfree = () => {
  if (!cashfreePromise) {
    cashfreePromise = load({ mode: CASHFREE_ENV }).catch((error) => {
      cashfreePromise = undefined;
      throw error;
    });
  }

  return cashfreePromise;
};
